/**
 *
 * PortalHeader
 *
 * @version 1.0.0
 * @author Vittorio
 * @since 19-Oct-2022
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography } from '@mui/material';
import PortalAnchorButton from 'Components/PortalAnchorButton';
import LogoDark from 'Assets/images/logo/logo_dark.svg';
import LogoLight from 'Assets/images/logo/logo_light.svg';
import style from './PortalHeader.scss';

const PortalHeader = (props) => (
	<Grid className={`${style.header} ${props.className} ${props.hasLightBackground ? style.light : ''}`}>
		{props.hasLogo && (
			<img src={`${props.hasLightBackground ? LogoDark : LogoLight}`} alt='Logo' className={style.logo} />
		)}
		{props.backCopy ? (
			<PortalAnchorButton
				color='secondary'
				navigationObject={{
					internalNavigation: {
						isReplace: props.isReplace,
						route: props.route,
					},
				}}
				textTransform='isUppercase'
				isTranslatedMessage={false}
				contentText={props.backCopy}
				onClickAction={props.backOnClick}
				startIcon='nexi-icons-incon-thin-left'
			/>
		) : null}
		<Typography variant='h5' align='center' className={style.title}>
			{props.title}
		</Typography>
	</Grid>
);

PortalHeader.propTypes = {
	// Add here some propTypes
	// and set a minimal description i.e.
	/** Description of prop "baz". */
	title: PropTypes.string,
	backCopy: PropTypes.string,
	backOnClick: PropTypes.func,
	className: PropTypes.string,
	route: PropTypes.string,
	hasLogo: PropTypes.bool,
	isReplace: PropTypes.bool,
	hasLightBackground: PropTypes.bool,
};

PortalHeader.defaultProps = {
	// Add here some default propTypes values
	title: '',
	backCopy: '',
	className: '',
	hasLogo: false,
	isReplace: false,
	hasLightBackground: false,
};

export default PortalHeader;
